import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Button                              from '@material-ui/core/Button'
import Checkbox                            from '@material-ui/core/Checkbox'
import Dialog                              from '@material-ui/core/Dialog'
import DialogActions                       from '@material-ui/core/DialogActions'
import DialogContent                       from '@material-ui/core/DialogContent'
import DialogTitle                         from '@material-ui/core/DialogTitle'
import FormControlLabel                    from '@material-ui/core/FormControlLabel'
import Typography                          from '@material-ui/core/Typography'
import { InjectedFormikProps, withFormik } from 'formik'
import { object, string }                  from 'yup'

import { FinalEvaluation }                 from '../../api'
import { canEditFinalEvaluation }          from '../../project-utils/permissions'
import { Communication }                   from '../../redux/ducks'
import {
  EnhancedTextField,
  InlineError,
  LoadingOverlay,
  PermissionGuard,
}                                          from '../atoms'
import withToggle, { InjectedToggleProps } from '../hocs/withToggle'
import {
  i18nErrorCodes,
  mapFormikToMuiProps,
}                                          from './form-utils'

interface FinalEvaluationProps extends FinalEvaluation {
  isOpen: boolean
  close: () => void
  communication: Communication
  onComplete: () => void
}

type Props =
  FinalEvaluationProps
  & InjectedToggleProps
  & InjectedFormikProps<any, any>

let lastProps: Props

const FinalEvaluationDialog: React.SFC<Props> = props => {
  const {
    onComplete,
    isOpen,
    done,
    summary,
    close,

    isActive,
    deactivate,
    activate,
    communication: { fetching, error },
  } = props

  /* componentDidUpdate on a budget :) */
  if (
    lastProps
    && lastProps.communication.fetching
    && props.communication.success
  ) {
    props.deactivate()
  }

  const phrasing = {
    agree:  <FormattedMessage id={'buttonActions.agree'} />,
    edit:   <FormattedMessage id={'buttonActions.edit'} />,
    save:   <FormattedMessage id={'buttonActions.save'} />,
    close:  <FormattedMessage id={'buttonActions.close'} />,
    cancel: <FormattedMessage id={'buttonActions.cancel'} />,
  }

  const mapper = mapFormikToMuiProps(props)

  lastProps = props

  return (
    <Dialog open={isOpen} fullWidth>
      <LoadingOverlay show={fetching}>
        <form onSubmit={props.handleSubmit}>
          <DialogTitle>
            <FormattedMessage id={'project.finalEvaluation'} />
          </DialogTitle>
          <DialogContent>
            {isActive
              ? (
                <EnhancedTextField
                  multiline
                  fullWidth
                  {...mapper('summary')}
                />
              )
              : (
                <Typography>
                  {summary}
                </Typography>
              )
            }

          </DialogContent>
          {error && (
            <DialogContent>
              <InlineError i18nErrorId={error} />
            </DialogContent>
          )}
          {!done && !isActive && (
            <DialogContent>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.values.checked}
                    onChange={
                      () => props.handleChange({
                        target: { value: !props.values.checked, name: 'checked' }
                      })}
                  />
                }
                label={(
                  <FormattedMessage id={'generic.iAgreeWithTheFinalEvaluation'} />
                )}
              />
            </DialogContent>
          )}
          <DialogActions>
            {isActive
              ? (
                <>
                  <Button
                    type={'submit'}
                    color={'primary'}
                  >
                    {phrasing.save}
                  </Button>
                  <Button
                    onClick={deactivate}
                    color={'primary'}
                  >
                    {phrasing.cancel}
                  </Button>
                </>
              )
              : (
                <>
                  {!done && (
                    <>
                      <Button
                        onClick={onComplete}
                        color={'primary'}
                        disabled={!props.values.checked}
                      >
                        {phrasing.agree}
                      </Button>
                      <PermissionGuard check={canEditFinalEvaluation}>
                        <Button
                          onClick={activate}
                          color={'primary'}
                        >
                          {phrasing.edit}
                        </Button>
                      </PermissionGuard>
                    </>
                  )}
                  <Button
                    onClick={close}
                    color={'primary'}
                  >
                    {phrasing.close}
                  </Button>
                </>
              )
            }
          </DialogActions>
        </form>
      </LoadingOverlay>
    </Dialog>
  )
}

const formik = {
  validationSchema: object().shape({ summary: string().required(i18nErrorCodes.required) }),
  mapPropsToValues: ({ summary }) => ({ summary: summary && summary.trim() || '', checked: false }),
  handleSubmit:     (values, bag) => {
    bag.props.onUpdate(values)
  }
}

export default withToggle(
  withFormik<any, any>(formik)(
    FinalEvaluationDialog
  )
)



// WEBPACK FOOTER //
// ./src/components/forms/FinalEvaluationDialog.tsx